import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Clock, MapPin, Car } from 'lucide-react';

const LocationVoitureChauffeurJournee = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Location Voiture avec Chauffeur à la Journée | Bruxelles</title>
        <meta name="description" content="Location voiture avec chauffeur à la journée à Bruxelles. Chauffeur à disposition, Mercedes Lexus. Idéal visites, rendez-vous, tourisme." />
        <meta name="keywords" content="location voiture chauffeur journée, chauffeur disposition bruxelles, location chauffeur privé" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/location-voiture-chauffeur-journee" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Location Voiture avec Chauffeur
          </h1>
          <p className="text-xl text-gray-300 text-center mb-8">
            Chauffeur privé à disposition à l&apos;heure ou à la journée. Flexibilité totale.
          </p>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultService="chauffeur" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Chauffeur Privé à Disposition</h2>
          <p className="text-gray-300 mb-4">
            <strong>Location de voiture avec chauffeur</strong> pour vos besoins professionnels ou personnels. 
            Chauffeur à disposition par heure, demi-journée ou journée complète. Véhicule premium Mercedes ou Lexus.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Formules Disponibles</h3>
          <ul className="text-gray-300 space-y-2">
            <li>⏱️ Location 3 heures (demi-journée)</li>
            <li>📅 Location 6 heures (journée)</li>
            <li>🌙 Location 8-10 heures (journée complète)</li>
            <li>💼 Forfait semaine sur devis</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default LocationVoitureChauffeurJournee;